import types from '../constants/actionTypes';
export * from './api';
export * from './router';
export * from './users';
export * from './influencers';
export * from './collectives';

export function clearLastErrorMessage() {
  return {
    type: types.errors.CLEAR_LAST_ERROR_MESSAGE,
  };
}

export function toggleView(view) {
  return {
    type: types.view.TOGGLE_ACTIVE_VIEW,
    view: view,
  };
}

export function incrementPage(incrementValue) {
  return {
    type: types.view.INCREMENT_PAGE,
    value: incrementValue,
  }
}

export function requestTabChange(value) {
  return {
    type: types.view.REQUEST_TAB_CHANGE,
    value: value,
  };
}

export function addErrorMessage({ status = '', message = '', autoHideDuration = null }) {
  return {
    type: types.errors.ADD_MESSAGE,
    status: status,
    message: message,
    autoHideDuration: autoHideDuration,
  };
}



/** WEBPACK FOOTER **
 ** ./actions/index.js
 **/